<ng-container *ngIf="type === 'VIDEO'; then videoResource"></ng-container>
<ng-container *ngIf="type === 'PDF'; then pdfResource"></ng-container>
<ng-container *ngIf="type === 'LINK'; then mediaResource"></ng-container>

<ng-template #videoResource>
  <span class="btn btn-link p-0 d-flex"><em
    class="me-2 ds-icon ds-icon--playbutton ds-icon--big"></em>{{'productDetails.watchVideo' | cxTranslate}}</span>
</ng-template>
<ng-template #pdfResource>
  <span class="btn btn-link p-0 d-flex"
        (click)="triggerEddlDownloadAttemptEvent(); triggerEddlDownloadSuccessEvent()"><em
    class="me-2 ds-icon ds-icon--file ds-icon--big"></em>{{'productDetails.readPdf' | cxTranslate}}</span>
</ng-template>
<ng-template #mediaResource>
  <span class="btn btn-link p-0 d-flex"><em
    class="me-2 ds-icon ds-icon--globe ds-icon--big"></em>{{'productDetails.visitWebsite' | cxTranslate}}</span>
</ng-template>
